import { newSpecPage } from '@stencil/core/testing'
import { CobaltTabsVertical } from '../cobalt-tabs-vertical'

describe('cobalt-tabs-vertical', () => {
  it('renders', async () => {
    const page = await newSpecPage({
      components: [CobaltTabsVertical],
      html: `
<cobalt-tabs-vertical>
  <cobalt-tab-panel label="Tab 1" icon-name="star-outline">
  <div class="custom-panel-content-class typography-body-medium-regular">content 1</div>
  </cobalt-tab-panel>
  <cobalt-tab-panel label="Tab 2" disabled="true" icon-name="star-outline">
  <div class="custom-panel-content-class typography-body-medium-regular">Disabled panel</div>
  </cobalt-tab-panel>
  <cobalt-tab-panel label="Tab 3" icon-name="star-outline">
  <div class="custom-panel-content-class typography-body-medium-regular">content 3</div>
  </cobalt-tab-panel>
</cobalt-tabs-vertical>
`
    })
    expect(page.root).toEqualHtml(`
      <cobalt-tabs-vertical>
        <div class="cobalt-tabs cobalt-tabs--vertical" id="tabs-vertical-0">
          <ul class="cobalt-tabs-list cobalt-tabs-list--small typography-monoline-medium" role="tablist">
            <li aria-controls="tabs-vertical-0_tab-panel-0" aria-disabled="false" aria-selected="true" class="cobalt-tab-item tab-item--selected" id="tab-label-0" role="tab" tabindex="0">
              <div class="tab-label-content">
                <cobalt-icon name="star-solid" size="number-size-icon-medium"></cobalt-icon>
                <span class="tab-label">
                  Tab 1
                </span>
              </div>
            </li>
            <li aria-controls="tabs-vertical-0_tab-panel-1" aria-disabled="true" aria-selected="false" class="cobalt-tab-item tab-item--disabled" id="tab-label-1" role="tab" tabindex="0">
              <div class="tab-label-content">
                <cobalt-icon name="star-outline" size="number-size-icon-medium"></cobalt-icon>
                <span class="tab-label">
                  Tab 2
                </span>
              </div>
            </li>
            <li aria-controls="tabs-vertical-0_tab-panel-2" aria-disabled="false" aria-selected="false" class="cobalt-tab-item" id="tab-label-2" role="tab" tabindex="0">
              <div class="tab-label-content">
                <cobalt-icon name="star-outline" size="number-size-icon-medium"></cobalt-icon>
                <span class="tab-label">
                  Tab 3
                </span>
              </div>
            </li>
          </ul>
          <div class="tab-content">
            <div aria-labelledby="tab-label-0" id="tabs-vertical-0_tab-panel-0" role="tabpanel" style="display: block;">
              <cobalt-tab-panel icon-name="star-outline" label="Tab 1" slot="tabs-vertical-0_tab-0">
                <div class="custom-panel-content-class typography-body-medium-regular">
                  content 1
                </div>
              </cobalt-tab-panel>
            </div>
            <div aria-labelledby="tab-label-1" id="tabs-vertical-0_tab-panel-1" role="tabpanel" style="display: none;">
              <cobalt-tab-panel disabled="true" icon-name="star-outline" label="Tab 2" slot="tabs-vertical-0_tab-1">
                <div class="custom-panel-content-class typography-body-medium-regular">
                  Disabled panel
                </div>
              </cobalt-tab-panel>
            </div>
            <div aria-labelledby="tab-label-2" id="tabs-vertical-0_tab-panel-2" role="tabpanel" style="display: none;">
              <cobalt-tab-panel icon-name="star-outline" label="Tab 3" slot="tabs-vertical-0_tab-2">
                <div class="custom-panel-content-class typography-body-medium-regular">
                  content 3
                </div>
              </cobalt-tab-panel>
            </div>
          </div>
        </div>
      </cobalt-tabs-vertical>
    `)
  })
})
